/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    string,
    array,
    bool,
    arrayOf,
    shape,
} from 'prop-types';
import { selectedSkuType } from '../common/types';
import GraphqlFoodDetailsUIDesktop from './GraphqlFoodDetailsUIDesktop';
import GraphqlFoodDetailsUIMobile from './GraphqlFoodDetailsUIMobile';
import DesktopMobile from '../../../../../helpers/DesktopMobile/DesktopMobile';

const GraphqlFoodDetailsUI = ({
    shortDescription,
    productContents,
    longDescription,
    clubDescription,
    selectedSku,
    content,
    isPassportBundleProduct,
}) => {
    const productContentsDescription = selectedSku?.longDescription || '';
    const additionalInformation = content?.entries?.[0]?.additional_information || [];

    return (
        <DesktopMobile
            desktop={() => (
                <GraphqlFoodDetailsUIDesktop
                    productContentsDescription={productContentsDescription}
                    shortDescription={shortDescription}
                    productContents={productContents}
                    longDescription={longDescription}
                    content={content}
                    selectedSku={selectedSku}
                    additionalInformation={additionalInformation}
                    isPassportBundleProduct={isPassportBundleProduct || {}}
                />
            )}
            mobile={() => (
                <GraphqlFoodDetailsUIMobile
                    productContentsDescription={productContentsDescription}
                    shortDescription={shortDescription}
                    productContents={productContents}
                    longDescription={longDescription}
                    clubDescription={clubDescription}
                    content={content}
                    selectedSku={selectedSku}
                    isPassportBundleProduct={isPassportBundleProduct || {}}
                />
            )}
        />
    );
};

GraphqlFoodDetailsUI.defaultProps = {
    clubDescription: false,
    selectedSku: {},
    content: {},
    isPassportBundleProduct: {},
};

GraphqlFoodDetailsUI.propTypes = {
    content: shape({
        entries: arrayOf(shape({
            // Gets dynamic data from contentstack. Either image or copy
            additional_information: array,
        })),
    }),
    clubDescription: bool,
    shortDescription: string.isRequired,
    productContents: array.isRequired,
    longDescription: string.isRequired,
    selectedSku: selectedSkuType,
    isPassportBundleProduct: shape({
        enable: bool,
    }),
};

export default GraphqlFoodDetailsUI;
